module.exports = __webpack_public_path__ + "static/media/DESTINATION-WEDDINGS-IN-PORTUGAL-VILA-GUIA-.68cc0da3.jpg";